import { render, staticRenderFns } from "./DesktopMenu.vue?vue&type=template&id=0c0baf0c&scoped=true&"
import script from "./DesktopMenu.vue?vue&type=script&lang=js&"
export * from "./DesktopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0baf0c",
  null
  
)

export default component.exports